<template>
  <div style="margin: auto; padding-bottom: 40px;">
    <div class="mycard">
      <div class="firstSearch">
        <svg
          t="1716340848113"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2049"
          width="20"
          height="20"
        >
          <path
            d="M911.8 839.6L750.9 678.7c120.1-160.6 87.2-388.1-73.3-508.2s-388.1-87.2-508.2 73.3c-46.9 62.8-72.3 139-72.3 217.4 0 200.5 162.5 363.1 363.1 363.1 78.4 0 154.6-25.4 217.4-72.3l160.8 160.8c20.2 20.3 53.1 20.3 73.4 0.1 20.2-20.2 20.2-53.1 0-73.3z m-451.7-119c-143.2 2-260.9-112.4-263-255.6-2-143.2 112.4-260.9 255.6-263h7.3c143.2 0 259.3 116.1 259.3 259.3S603.4 720.6 460.1 720.6z"
            p-id="2050"
            fill="#8a8a8a"
          ></path>
        </svg>
        <span style="font-size: 20px">&nbsp;Search</span>
      </div>
      <el-input
        placeholder="Enter species name, genus name, family name, group name... "
        v-model="userInput"
        @input="inputContent"
        style="width: 800px"
        clearable
      >
      </el-input>

      <div class="A_Search">
        <svg
          t="1716340836294"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6805"
          width="20"
          height="20"
        >
          <path
            d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"
            p-id="6806"
            fill="#8a8a8a"
          ></path>
          <path
            d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"
            p-id="6807"
            fill="#8a8a8a"
          ></path>
        </svg>
        <span style="font-size: 20px">&nbsp;Advanced&nbsp;Search</span>
      </div>
<!-- advance -->
      <div style="display: flex; flex-wrap: wrap; width: 100%;">
        <div style="width: 1000px; display: flex; flex-wrap: wrap">
          <div class="inputs">
            <label>Group: &nbsp;</label
            >
            <el-select
              v-model="userInputGroup"
              clearable
              @change="handleTaxonomyChange"
            >
              <el-option
                v-for="item in groupList"
                :key="item.value"
                :label="replaceName(item.value)"
                :value="item.value"
              ></el-option>
            </el-select>
     
            <!-- <el-autocomplete
              v-model="userInputGroup"
              filterable
              clearable
              :fetch-suggestions="querySearchGroupList"
              @input="loadAll2"
            >
              <i class="el-icon-edit el-input__icon" slot="suffix"> </i
            ></el-autocomplete> -->
          </div>
          <div class="inputs" style="margin: 0 0 0 18px">
            <label>Class: </label
            >
            <el-select
              v-model="userInputClass"
              clearable
              @change="handleTaxonomyChange"
            >
              <el-option
                v-for="item in classList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-autocomplete
              v-model="userInputClass"
              :fetch-suggestions="querySearchClassList"
              @input="loadAll2"
              ><i class="el-icon-edit el-input__icon" slot="suffix"> </i
            ></el-autocomplete> -->
          </div>
          <div class="inputs">
            <label>Order: </label
            >
            <el-select
              v-model="userInputOrder"
              clearable
              @change="handleTaxonomyChange"
            >
              <el-option
                v-for="item in orderList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-autocomplete
              v-model="userInputOrder"
              :fetch-suggestions="querySearchOrderList"
              @input="loadAll2"
              ><i class="el-icon-edit el-input__icon" slot="suffix"> </i
            ></el-autocomplete> -->
          </div>
          <div class="inputs">
            <label>Family: </label
            >
            <el-select
              v-model="userInputFamily"
              clearable
              @change="handleTaxonomyChange"
            >
              <el-option
                v-for="item in familyList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-autocomplete
              v-model="userInputFamily"
              :fetch-suggestions="querySearchFamilyList"
              @input="loadAll2"
              ><i class="el-icon-edit el-input__icon" slot="suffix"> </i
            ></el-autocomplete> -->
          </div>
          <div class="inputs">
            <label>Genus: </label
            >
            <el-select
              v-model="userInputGenus"
              clearable
              @change="handleTaxonomyChange"
            >
              <el-option
                v-for="item in genusList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-autocomplete
              v-model="userInputGenus"
              :fetch-suggestions="querySearchGenusList"
              @input="loadAll2"
              ><i class="el-icon-edit el-input__icon" slot="suffix"> </i
            ></el-autocomplete> -->
          </div>
        </div>
        <div>
          <el-button type="primary" @click="getGenomesList" plain
            >Search</el-button
          >
          <el-button type="danger" @click="clear" plain>Clear</el-button>
        </div>
      </div>
    </div>
    <div class="below">
      <div class="Statistics">
        <div class="title" style="align-items: center;">
          <svg
            t="1716341120350"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2307"
            width="20"
            height="20"
            style="margin-top: 0; margin-bottom: 0;"
          >
            <path
              d="M868.7 126.6H157.3c-32.7 0-59.3 26.5-59.3 59.3 0 32.7 26.5 59.3 59.3 59.3h711.4c32.7 0 59.3-26.5 59.3-59.3 0-32.7-26.5-59.3-59.3-59.3z m0 652.2H157.3c-32.7 0-59.3 26.5-59.3 59.3 0 32.7 26.5 59.3 59.3 59.3h711.4c32.7 0 59.3-26.5 59.3-59.3s-26.5-59.3-59.3-59.3z m0-326.1H157.3c-32.7 0-59.3 26.5-59.3 59.3 0 32.7 26.5 59.3 59.3 59.3h711.4c32.7 0 59.3-26.5 59.3-59.3 0-32.7-26.5-59.3-59.3-59.3z"
              p-id="2308"
              fill="#8a8a8a"
            ></path>
          </svg>
          <span style="font-size: 24px; margin-left: 10px; margin-right: 24px;">Statistics</span>
          <div style="display: flex; align-items: center; font-size: 14px; color: #606266;">
            Show
            <el-dropdown @command="changeValue" style="margin: 0 10px;">
              <el-button type="info" size="small">
                <span>{{ queryInfo.pagesize }}</span
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in option"
                  :key="item.value"
                  :command="item.label"
                  ><span> {{ item.label }}</span></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            entries
          </div>

          <!-- 把底部的下载按钮搬到了这里，并顶到最右侧 -->
          <div style="margin-left: auto; display: flex; align-items: center;">
            <download-excel
              class="export-excel-wrapper"
              :data="selectedRows && selectedRows.length > 0 ? selectedRows : genomesList"
              :fields="excelFields"
              type="csv"
              name="Genome_Infor_Result.csv"
            >
              <el-tooltip class="item" effect="dark" content="Export information of selected genomes or all entries on current page" placement="top">
                <el-button style="background-color: #9c27b0; border-color: #9c27b0; color: white;">Download genome information</el-button>
              </el-tooltip>
            </download-excel>       
            <el-tooltip class="item" effect="dark" content="Download all gene sequences of selected genomes" placement="top">
              <el-button type="warning" @click="downloadGeneData" style="margin-left: 15px;">Download gene set sequences</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Heatmap of 24 core genes in selected genomes" placement="top">
              <el-button type="primary" @click="drawHeatMap" style=" margin-left: 15px;">Draw heatmap</el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Phylogenetic analysis based on 24 core genes in selected genomes" placement="top">
              <el-button type="success" @click="constructPhyloTree" style="margin-left: 15px;">Phylogenetic analysis</el-button>
            </el-tooltip>
          </div>
        </div>
      </div>

      <!-- 选中的物种标签展示区 -->
      <div v-if="names && names.length > 0" style="padding: 16px 0 8px 0; display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
        <span style="font-size: 14px; font-weight: bold; color: #606266;">Selected Species ({{names.length}}):</span>
        <el-button type="danger" size="mini" plain @click="clearSelectedSpecies" style="padding: 5px 10px;">Clear All</el-button>
        <el-tag
          v-for="(name, index) in names"
          :key="index"
          type="primary"
          effect="plain"
          size="small"
          style="font-style: italic; border-radius: 4px;"
        >
          {{ name }}
        </el-tag>
      </div>

      <template>
        <el-table
          :data="genomesList"
          :row-key="row => row.assembly"
          ref="educeTable"
          id="educe-table"
          style="width: 100%; margin: auto"
          justify="center"
          @selection-change="handleSelectionChange"
          stripe
          :cell-style="cellStyle"
          highlight-current-row
          @sort-change="sortChange"
          border
        >
          <el-table-column
            prop="name"
            label="Species / Organism"
            fixed="left"
            width="220"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div @click="viewDetail(scope.row)" style="cursor: pointer">
                <!-- 页面跳转 -->
                <span
                  v-for="(word, index) in scope.row.name.split(' ')"
                  :key="index"
                  :class="{ italic: index < 2 }"
                >
                  {{ word }} </span
                ><svg
                  t="1729488067555"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="6358"
                  width="15"
                  height="15"
                >
                  <path
                    d="M511.947176 511.947176m-511.947176 0a511.947176 511.947176 0 1 0 1023.894353 0 511.947176 511.947176 0 1 0-1023.894353 0Z"
                    fill="#7D9EF8"
                    p-id="6359"
                  ></path>
                  <path
                    d="M466.039477 2.029172A517.997461 517.997461 0 0 1 511.947176 0c282.734463 0 511.947176 229.203405 511.947177 511.947176 0 8.684486-0.195471 17.313123-0.632953 25.895219-15.125712 1.349679-30.437587 2.029172-45.9077 2.029173-282.734463 0-511.947176-229.203405-511.947176-511.947177 0-8.684486 0.204779-17.313123 0.632953-25.895219z"
                    fill="#FFFFFF"
                    opacity=".1"
                    p-id="6360"
                  ></path>
                  <path
                    d="M474.714654 1022.553982V780.952147C261.53985 766.729324 93.081305 590.787042 93.081305 375.862309l0.074465-7.939836a13.766725 13.766725 0 0 1 13.012766-13.515405l5.836198-0.29786A409.557741 409.557741 0 0 1 130.313827 353.708958c165.219316 0 307.587172 96.981411 372.325219 236.64991 3.565014 7.6699 15.051247 7.6699 18.616261 0C585.993354 450.69037 728.36121 353.708958 893.580526 353.708958c6.906633 0 13.757417 0.167546 20.56166 0.502639 9.289514 0.44679 16.568472 8.004992 16.652246 17.285199l0.018616 4.356205c0 218.070881-173.382546 395.967871-390.94148 405.620402v241.676299a518.742112 518.742112 0 0 1-65.156914-0.59572z"
                    fill="#F0F4FF"
                    p-id="6361"
                  ></path>
                </svg>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="assembly"
            label="Assembly"
            width="150"
            sortable="custom"
          >
            <template slot-scope="scope">
              <div @click="viewDetail(scope.row)" style="cursor: pointer">
                <!-- 页面跳转 -->
                {{ scope.row.assembly }}
                <svg
                  t="1705483325226"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2155"
                  width="15"
                  height="15"
                >
                  <path
                    d="M790.536784 923.653571 77.292364 923.653571 77.292364 228.828662 625.784486 228.828662 625.784486 264.644379 113.108081 264.644379 113.108081 887.837854 753.697761 887.837854 753.697761 410.977165 790.536784 410.977165Z"
                    fill="#14AEED"
                    p-id="2156"
                  ></path>
                  <path
                    d="M904.925691 115.801844l25.885344 25.885344-400.116482 400.116482-25.885344-25.885344 400.116482-400.116482Z"
                    fill="#14AEED"
                    p-id="2157"
                  ></path>
                  <path
                    d="M932.909375 340.16233 896.369158 338.016457 908.096247 138.5311 708.61089 150.258189 706.465017 113.717971 947.06784 99.559507Z"
                    fill="#14AEED"
                    p-id="2158"
                  ></path>
                </svg>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="group"
            label="Group"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ replaceName(scope.row.group) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="classes"
            label="Class"
            width="140"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="order"
            label="Order"
            width="140"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="family"
            label="Family"
            width="150"
            sortable="custom"
          ></el-table-column>

          <el-table-column
            prop="genus"
            label="Genus"
            width="150"
            sortable="custom"
          ></el-table-column>

          <el-table-column
            prop="size"
            label="Size (bp)"
            width="120"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ formatSize(scope.row.size) }}
            </template></el-table-column
          >
          <el-table-column
            prop="gc"
            label="GC (%)"
            width="100"
            sortable="custom"
          ></el-table-column>
          <!-- 新增列 -->
          <el-table-column
            prop="definition"
            label="Total genes"
            width="130"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="bioProject"
            label="PCGs"
            width="90"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="bioSample"
            label="Conserved genes"
            width="170"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="keyWords"
            label="rRNAs"
            width="90"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            prop="journal"
            label="tRNAs"
            width="90"
            sortable="custom"
          ></el-table-column>

          <el-table-column
            type="selection"
            :reserve-selection="true"
            fixed="right"
            width="60"
          ></el-table-column>
        </el-table>
        <div style="display: flex; width: 100%; margin: auto; align-items: center; justify-content: space-between;">
          <div
            class="block"
            style="margin: 20px 0; display: inline-block;"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="queryInfo.pagesize"
              layout="prev, pager, next, jumper"
              :total="count"
              :current-page.sync="queryInfo.pagenum"
            >
            </el-pagination>
          </div>
          <div style="display: flex; align-items: center; gap: 15px; margin: 20px 0;">
            <el-tooltip class="item" effect="dark" content="Download genome sequences (.fasta) of selected species" placement="top">
              <el-button type="info" size="small" @click="downloadGenomeSequence" style="background-color: #00bcd4; border-color: #00bcd4; color: white;">Download genome sequence</el-button>
            </el-tooltip>
            <span style="color: #606266; font-size: 14px;"
              >Showing
              {{
                count == 0 ? 0 : (queryInfo.pagenum - 1) * queryInfo.pagesize + 1
              }}
              to
              {{
                queryInfo.pagenum * queryInfo.pagesize > count
                  ? count
                  : queryInfo.pagenum * queryInfo.pagesize
              }}
              of {{ count }} entries</span
            >
          </div>
        </div>
      </template>
    </div>
    </div>
</template>
<script>
// 假设 taxonomyDict 是你的大字典
import taxonomyDict from './taxonomy-data.js';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Genomes",
  components: {  },
  data() {
    return {
      isSelectionAdjusting: false,
      scrollTop: 0,
      // 名称替换映射表
      nameMap: {
        Phycophyta: "Algae",
        Angiosperm: "Angiosperms",
        Gymnosperm: "Gymnosperms",
        Bryophyte: "Bryophytes",
        Pteridophyte: "Pteridophytes",
      },
      title: "Genome_Infor_Result", //excel表头
      // activeClass: "",
      queryInfo: {
        pagenum: 1, //当前页面
        pagesize: 10, //页面大小
      },
      count: 0,
      sort: "name",
      sortMethod: "",
      genomesList: [],
      downLoadList: [], //fasta文件下载
      userInput: "",
// 级连检索表
      taxonomyDict: taxonomyDict, // 完整字典数据
      userInputGroup: "",
      userInputClass: "",
      userInputOrder: "",
      userInputFamily: "",
      userInputGenus: "",
      flattenedTaxonomy: [],
      option: [
        //页面大小
        { label: 10, value: 0 },
        { label: 25, value: 1 },
        { label: 50, value: 2 },
        { label: 100, value: 3 },
      ],
      species: [],
      names: [],
      selectedRows: [],
      excelFields: {
        "Species": "name",
// 名称替换
        "Group": {
          field: "group",
          callback: (value) => {
            if (!value) return value;
            const map = { Phycophyta: "Algae", Angiosperm: "Angiosperms", Gymnosperm: "Gymnosperms", Bryophyte: "Bryophytes", Pteridophyte: "Pteridophytes" };
            return map[value] || value;
          }
        },
        "Class": "classes",
        "Order": "order",
        "Family": "family",
        "Genus": "genus",
        "Size (bp)": "size",
        "GC (%)": "gc",
        "Assembly": "assembly"
      },
      genes: [
        "atp1",
        "atp4",
        "atp6",
        "atp8",
        "atp9",
        "ccmB",
        "ccmC",
        "ccmFc",
        "ccmFn",
        "cob",
        "cox1",
        "cox2",
        "cox3",
        "matR",
        "mttB",
        "nad1",
        "nad2",
        "nad3",
        "nad4",
        "nad4L",
        "nad5",
        "nad6",
        "nad7",
        "nad9",
      ],
    };
  },
  created() {
    this.getGenomesList();
    // this.loadAll();
    // this.loadAll2();
  },
  mounted() {
    this.initTaxonomyData();
  },
  methods: {
    // 名称替换方法
    replaceName(name) {
      return (name && this.nameMap[name]) || name;
    },
    initTaxonomyData() {
      // 遍历 taxonomyDict 生成扁平化数组，用于前端层级联动
      for (const group in this.taxonomyDict) {
        for (const cls in this.taxonomyDict[group]) {
          for (const order in this.taxonomyDict[group][cls]) {
            for (const family in this.taxonomyDict[group][cls][order]) {
              for (const genus in this.taxonomyDict[group][cls][order][family]) {
                this.flattenedTaxonomy.push({
                  group: group,
                  class: cls,
                  order: order,
                  family: family,
                  genus: genus
                });
              }
            }
          }
        }
      }
    },
    handleTaxonomyChange() {
      // 下方检索时，自动清空上方基础参数，实现隔离
      this.userInput = "";

      // 检查当前选中项，如果某个层级选中后，其父级唯一，则自动填充父级
      let filtered = this.flattenedTaxonomy;

      if (this.userInputGenus) filtered = filtered.filter(i => i.genus === this.userInputGenus);
      if (this.userInputFamily) filtered = filtered.filter(i => i.family === this.userInputFamily);
      if (this.userInputOrder) filtered = filtered.filter(i => i.order === this.userInputOrder);
      if (this.userInputClass) filtered = filtered.filter(i => i.class === this.userInputClass);
      if (this.userInputGroup) filtered = filtered.filter(i => i.group === this.userInputGroup);

      // Determine the most specific level currently selected
      // 0: Group, 1: Class, 2: Order, 3: Family, 4: Genus
      let lowestSelected = -1;
      if (this.userInputGenus) lowestSelected = 4;
      else if (this.userInputFamily) lowestSelected = 3;
      else if (this.userInputOrder) lowestSelected = 2;
      else if (this.userInputClass) lowestSelected = 1;
      else if (this.userInputGroup) lowestSelected = 0;

      // 严格限制为“向上推导补全”，禁止向下补全
      if (filtered.length > 0) {
        if (lowestSelected >= 4) {
          const uniqueFamilies = Array.from(new Set(filtered.map(i => i.family)));
          if (uniqueFamilies.length === 1 && !this.userInputFamily) {
            this.userInputFamily = uniqueFamilies[0];
          }
        }

        if (lowestSelected >= 3) {
          const uniqueOrders = Array.from(new Set(filtered.map(i => i.order)));
          if (uniqueOrders.length === 1 && !this.userInputOrder) {
            this.userInputOrder = uniqueOrders[0];
          }
        }

        if (lowestSelected >= 2) {
          const uniqueClasses = Array.from(new Set(filtered.map(i => i.class)));
          if (uniqueClasses.length === 1 && !this.userInputClass) {
            this.userInputClass = uniqueClasses[0];
          }
        }

        if (lowestSelected >= 1) {
          const uniqueGroups = Array.from(new Set(filtered.map(i => i.group)));
          if (uniqueGroups.length === 1 && !this.userInputGroup) {
            this.userInputGroup = uniqueGroups[0];
          }
        }
      }
    },
    clear() {
      this.userInputGroup = "";
      this.userInputClass = "";
      this.userInputOrder = "";
      this.userInputFamily = "";
      this.userInputGenus = "";
    },
// 级连数据清除
// 结束
    changeArrayToString() {
      var strs = [];
      this.advanced.forEach((element) => {
        strs.push("" + element.key + ":" + element.value);
      });
      return strs;
    },
    async changeValue(e) {
      //改变页面大小
      this.queryInfo.pagesize = e;
      this.handleCurrentChange(1);
    },
    async inputContent(e) {
      this.userInput = e;
      // 上方检索时，自动清空下方高级参数，实现隔离
      this.clear();
      var strs = this.changeArrayToString();
      var that = this;
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genomes/list", {
          params: {
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            advanced: strs,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.count = res.data.count;
        this.genomesList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async getGenomesList() {
      if (
        sessionStorage.getItem("userInputHome") != null &&
        sessionStorage.getItem("userInputHome") != ""
      ) {
        this.userInput = sessionStorage.getItem("userInputHome");
        sessionStorage.setItem("userInputHome", "");
      }

      // 智能识别输入的层级并做回退判断
      let inputStr = this.userInput ? this.userInput.trim() : "";
      if (inputStr) {
        // 进行一刀切，只要顶部搜索框有内容，立刻清空下方所有高级检索参数以避免冲突
        this.clear();

        const inputLower = inputStr.toLowerCase();
        let matchedLevel = null;
        let matchedValue = null;

        // 优先尝试匹配最低层级 (Genus -> Family -> Order -> Class -> Group)
        const matchGenus = this.flattenedTaxonomy.find(i => i.genus.toLowerCase() === inputLower);
        if (matchGenus) { matchedLevel = 'Genus'; matchedValue = matchGenus.genus; }
        else {
          const matchFamily = this.flattenedTaxonomy.find(i => i.family.toLowerCase() === inputLower);
          if (matchFamily) { matchedLevel = 'Family'; matchedValue = matchFamily.family; }
          else {
            const matchOrder = this.flattenedTaxonomy.find(i => i.order.toLowerCase() === inputLower);
            if (matchOrder) { matchedLevel = 'Order'; matchedValue = matchOrder.order; }
            else {
              const matchClass = this.flattenedTaxonomy.find(i => i.class.toLowerCase() === inputLower);
              if (matchClass) { matchedLevel = 'Class'; matchedValue = matchClass.class; }
              else {
                const matchGroup = this.flattenedTaxonomy.find(i => i.group.toLowerCase() === inputLower);
                if (matchGroup) { matchedLevel = 'Group'; matchedValue = matchGroup.group; }
              }
            }
          }
        }

        // 如果在字典中找到了精确匹配的层级
        if (matchedLevel) {
          // 填入对应的层级
          if (matchedLevel === 'Genus') this.userInputGenus = matchedValue;
          if (matchedLevel === 'Family') this.userInputFamily = matchedValue;
          if (matchedLevel === 'Order') this.userInputOrder = matchedValue;
          if (matchedLevel === 'Class') this.userInputClass = matchedValue;
          if (matchedLevel === 'Group') this.userInputGroup = matchedValue;
          
          // 触发向上补全逻辑
          this.handleTaxonomyChange();
          
          // 将基础搜索框清空，因为它已经被转换成高级搜索条件了
          this.userInput = "";
        }
      }

      var strs = this.changeArrayToString();
      var that = this;
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genomes/list", {
          params: {
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            advanced: strs,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.count = res.data.count;
        this.genomesList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    async handleCurrentChange(val) {
      var strs = this.changeArrayToString();
      var that = this;
      //底部分页按钮
      const { data: res } = await this.$axios.get("/api/api.genomes/list", {
        params: {
          page: val,
          pageSize: this.queryInfo.pagesize,
          search: this.userInput,
          sort: this.sort,
          method: this.sortMethod,
          advanced: strs,
        },
        paramsSerializer: function (params) {
          return that.$qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      // 赋值
      this.queryInfo.pagenum = val;
      this.genomesList = res.data.rows;
    },
    clearSelectedSpecies() {
      if (this.$refs.educeTable) {
        this.$refs.educeTable.clearSelection();
      }
      this.species = [];
      this.names = [];
      this.selectedRows = [];
    },
    handleSelectionChange(list) {
      //用于生成热图数组
      if (this.isSelectionAdjusting) return;
      if (list.length > 10) {
        this.isSelectionAdjusting = true;
        this.$message.warning("You can select at most 10 species.");
        const keepList = list.slice(0, 10);
        const discardList = list.slice(10);
        discardList.forEach(row => {
          this.$refs.educeTable.toggleRowSelection(row, false);
        });
        list = keepList;
        this.isSelectionAdjusting = false;
      }

      this.species = [];
      this.names = [];
      this.selectedRows = list;
      for (var i = 0; i < list.length; i++) {
        this.species.push(list[i].assembly);
        this.names.push(list[i].name);
      }
      sessionStorage.setItem("HeatMapNCs", this.species);
    },
    async drawHeatMap() {
      if (!this.names || this.names.length < 1) {
        this.$message.warning("Please select at least 1 species to draw heatmap.");
        return;
      }
      let that = this;
      await this.$axios
        .get("api/api.echarts/heatmap", {
          params: {
            assembly: this.species,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          console.log(res.data);

          const data = res.data.data;
          let csvContent = "Species,";
          this.names.forEach((row) => {
            csvContent += `${row},`;
          });
          // 添加CSV标题行
          let i = 0;
          // 遍历数据并构建CSV内容
          data.forEach((row) => {
            if (row[1] == 0) {
              csvContent = csvContent.slice(0, -1);
              csvContent += "\n";
              csvContent += `${this.genes[i]},`;
              i++;
            }
            csvContent += `${row[2]},`;
          });
          csvContent = csvContent.slice(0, -1);

          sessionStorage.setItem("heatMapCsvData", csvContent);
          that.$router.push({ name: 'HeatMapTool' });
        });
    },
    async downloadGeneData() {
      if (!this.names || this.names.length < 1) {
        this.$message.warning("Please select at least 1 species to download gene data.");
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: 'Downloading gene data...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let speciesDictArray = this.names.map((name, index) => {
        return {
          species: name,
          assembly: this.species[index]
        };
      });
      let geneArray = []; 

      try {
        const { data: res } = await this.$axios.post("api/api.genomes/download_genes", {
          species_dict: speciesDictArray,
          genes: geneArray
        });
        
        loading.close();
        
        if (res && res.code === 200) {
          const fastaContent = res.data;
          const blob = new Blob([fastaContent], { type: "text/plain;charset=utf-8;" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", "gene_data.fasta");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.$message.error(res.message || "Failed to download gene data.");
        }
      } catch (error) {
        loading.close();
        console.error(error);
        this.$message.error("An error occurred while downloading gene data.");
      }
    },
    async constructPhyloTree() {
      if (!this.names || this.names.length < 3) {
        this.$message.warning("Please select at least 3 species to construct a phylogenetic tree.");
        return;
      }
      if (this.names.length > 20) {
        this.$message.warning("Please select no more than 20 species to construct a phylogenetic tree.");
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: 'Constructing phylogenetic tree...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let speciesDictArray = this.names.map((name, index) => {
        return {
          species: name,
          assembly: this.species[index]
        };
      });
      let geneArray = []; // The user requested it to default to empty

      try {
        const { data: res } = await this.$axios.post("api/api.genomes/phylotree", {
          species_dict: speciesDictArray,
          genes: geneArray
        });
        
        if (res && res.code === 202) {
          const taskId = res.task_id;
          loading.text = 'Task queued. Waiting for execution...';
          
          const pollInterval = setInterval(async () => {
            try {
              const { data: statusRes } = await this.$axios.get(`api/api.genomes/phylotree_status/${taskId}`);
              const statusData = statusRes.data;
              
              if (statusData.state === 'PENDING') {
                loading.text = 'Queued in background...';
              } else if (statusData.state === 'SUCCESS') {
                clearInterval(pollInterval);
                loading.close();
                
                const finalRes = statusData.result;
                if (finalRes && finalRes.code === 200) {
                  const treeData = finalRes.data; 
                  sessionStorage.setItem('treeData', typeof treeData === 'string' ? treeData : JSON.stringify(treeData));
                  
                  this.$router.push({
                    name: "PhylogeneticTree",
                    params: {
                      treeData: typeof treeData === 'string' ? treeData : JSON.stringify(treeData)
                    }
                  });
                } else {
                  this.$message.error(finalRes.message || "Failed to generate tree.");
                }
              } else if (statusData.state === 'FAILURE') {
                clearInterval(pollInterval);
                loading.close();
                this.$message.error("Task failed: " + statusData.status);
              } else {
                loading.text = 'Constructing phylogenetic tree...';
              }
            } catch (pollErr) {
              console.error(pollErr);
            }
          }, 3000); // Poll every 3 seconds

        } else {
          loading.close();
          this.$message.error("Failed to submit task to server.");
        }
      } catch (error) {
        loading.close();
        console.error(error);
        this.$message.error("An error occurred while submitting the task.");
      }
    },
    async tableDOWNLOAD() {
      var strs = this.changeArrayToString();
      if (!this.userInput) {
        this.userInput = "";
      }
//直接使用相对地址写法，避免报错，请求 API 时完全不需要带上域名。浏览器会自动帮你补全
      // const targetUrl =
      //         "http://" +
      //         this.$store.state.baseurl +
      //         ":80/api/api.genomes/excel?page=" +
      //         this.queryInfo.pagenum +
      //         "&pageSize=" +
      //         this.queryInfo.pagesize +
      //         "&search=" +
      //         this.userInput +
      //         "&sort=" +
      //         this.sort +
      //         "&method=" +
      //         this.sortMethod +
      //         "&advanced=" +
      //         strs;
      const targetUrl =
        "http://www.pmgdb.cn" +
        "/api/api.genomes/excel?page=" +
        this.queryInfo.pagenum +
        "&pageSize=" +
        this.queryInfo.pagesize +
        "&search=" +
        this.userInput +
        "&sort=" +
        this.sort +
        "&method=" +
        this.sortMethod +
        "&advanced=" +
        strs;
      // 在新窗口中打开目标URL
      window.open(targetUrl);
      this.$router.go(0);
    },
    viewDetail(row) {
      //跳转Species界面
      // 保存对象到 sessionStorage
      const serializedObject = JSON.stringify(row);
      sessionStorage.setItem("info", serializedObject);
      const targetUrl = this.$router.resolve({ path: "/Species" }).href;
      // 在新窗口中打开目标URL
      window.open(targetUrl, "_blank");
    },
    cellStyle({ columnIndex }) {
      // 改变某单元格的背景色及文字颜色
      if (columnIndex === 1 || columnIndex === 0) {
        return "color:blue !important";
      }
    },
    querySearchGroupList(queryString, cb) {
      var groupList = this.groupList;
      var results = queryString
        ? groupList.filter(this.createGroupFilter(queryString))
        : groupList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createGroupFilter(queryString) {
      return (groupList) => {
        return (
          groupList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearchClassList(queryString, cb) {
      var classList = this.classList;
      var results = queryString
        ? classList.filter(this.createClassFilter(queryString))
        : classList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createClassFilter(queryString) {
      return (classList) => {
        return (
          classList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearchOrderList(queryString, cb) {
      var orderList = this.orderList;
      var results = queryString
        ? orderList.filter(this.createClassFilter(queryString))
        : orderList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createOrderFilter(queryString) {
      return (orderList) => {
        return (
          orderList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    querySearchFamilyList(queryString, cb) {
      var familyList = this.familyList;
      var results = queryString
        ? familyList.filter(this.createClassFilter(queryString))
        : familyList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFamilyFilter(queryString) {
      return (familyList) => {
        return (
          familyList.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    querySearchGenusList(queryString, cb) {
      var genusList = this.genusList;
      var results = queryString
        ? genusList.filter(this.createClassFilter(queryString))
        : genusList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createGenusFilter(queryString) {
      return (genusList) => {
        return (
          genusList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
// 家在全部的分类层级检索表
    async loadAll() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get(
          "/api/api.genomes/advanced"
        );
        // 赋值

        this.groupList = res.data.groupList;
        this.familyList = res.data.familyList;
        this.genusList = res.data.genusList;
        this.classList = res.data.classList;
        this.orderList = res.data.orderList;
      } catch (err) {
        console.log(err);
      }
    },
    async loadAll2() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get(
          "/api/api.genomes/advanced",
          {
            params: {
              groupList_value: this.userInputGroup,
              familyList_value: this.userInputFamily,
              classList_value: this.userInputClass,
              genusList_value: this.userInputGenus,
              orderList_value: this.userInputOrder,
            },
          }
        );

        // 赋值
        this.groupList = res.data.groupList;
        this.familyList = res.data.familyList;
        this.genusList = res.data.genusList;
        this.classList = res.data.classList;
        this.orderList = res.data.orderList;
      } catch (err) {
        console.log(err);
      }
    },
    async sortChange(object) {
      var strs = this.changeArrayToString();
      var that = this;
      this.sort = object.prop;
      if (object.order == "descending") {
        this.sortMethod = "DESC";
      } else if (object.order == "ascending") {
        this.sortMethod = "ASC";
      }
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get("/api/api.genomes/list", {
          params: {
            page: 1,
            pageSize: this.queryInfo.pagesize,
            search: this.userInput,
            sort: this.sort,
            method: this.sortMethod,
            advanced: strs,
          },
          paramsSerializer: function (params) {
            return that.$qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        // 赋值
        this.queryInfo.pagenum = 1;
        this.count = res.data.count;
        this.genomesList = res.data.rows;
      } catch (err) {
        console.log(err);
      }
    },
    formatSize(size) {
      return size.toLocaleString(); // 使用 toLocaleString 方法进行格式化
    },
    downloadGenomeSequence() {
      if (!this.species || this.species.length < 1) {
        this.$message.warning("Please select at least 1 species to download genome sequence.");
        return;
      }

      const promises = [];
      const failedAccessions = [];

      this.species.forEach(asm => {
        if (!asm) return;
        const accessions = this.expandAccessionRange(asm);
        accessions.forEach(accession => {
          const trimmed = accession.trim();
          if (!trimmed) return;
          const downloadUrl = `/page/JBrowse/mydata/${trimmed}.fasta`;

          const p = this.$axios.get(downloadUrl, { responseType: 'blob' })
            .then(response => {
              const blob = new Blob([response.data], { type: 'application/octet-stream' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${trimmed}.fasta`);
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
            })
            .catch(error => {
              failedAccessions.push(trimmed);
              console.warn(`Genome sequence file for ${trimmed} not found or failed to download.`, error);
            });
          promises.push(p);
        });
      });

      Promise.all(promises).then(() => {
        if (failedAccessions.length > 0) {
          this.$message.warning(`The genome sequence file(s) for the following accessions are currently unavailable on the server: ${failedAccessions.join(', ')}.`);
        }
      });
    },
    expandAccessionRange(asm) {
      if (!asm) return [];
      const parts = asm.split('-');
      if (parts.length !== 2) {
        return [asm];
      }

      const startAcc = parts[0].trim();
      const endAcc = parts[1].trim();

      // Pattern 1: Range on digits before dot (e.g. PP764533.1-PP764541.1, ON890398.1-ON890401.1)
      const regexBeforeDot = /^([A-Za-z_]+)(\d+)(\..*)$/;
      const matchStart1 = startAcc.match(regexBeforeDot);
      const matchEnd1 = endAcc.match(regexBeforeDot);

      if (matchStart1 && matchEnd1) {
        const prefixStart = matchStart1[1];
        const numStartStr = matchStart1[2];
        const suffixStart = matchStart1[3];

        const prefixEnd = matchEnd1[1];
        const numEndStr = matchEnd1[2];
        const suffixEnd = matchEnd1[3];

        if (prefixStart === prefixEnd && suffixStart === suffixEnd) {
          const numStart = parseInt(numStartStr, 10);
          const numEnd = parseInt(numEndStr, 10);
          if (numStart <= numEnd && (numEnd - numStart) <= 100) {
            const list = [];
            const padLength = numStartStr.length;
            for (let i = numStart; i <= numEnd; i++) {
              const paddedNum = String(i).padStart(padLength, '0');
              list.push(`${prefixStart}${paddedNum}${suffixStart}`);
            }
            return list;
          }
        }
      }

      // Pattern 2: Range on digits after dot (e.g. PMGD000006.1-PMGD000006.9)
      const regexAfterDot = /^([A-Za-z_]+\d+\.)(\d+)$/;
      const matchStart2 = startAcc.match(regexAfterDot);
      const matchEnd2 = endAcc.match(regexAfterDot);

      if (matchStart2 && matchEnd2) {
        const prefixStart = matchStart2[1];
        const numStartStr = matchStart2[2];
        
        const prefixEnd = matchEnd2[1];
        const numEndStr = matchEnd2[2];

        if (prefixStart === prefixEnd) {
          const numStart = parseInt(numStartStr, 10);
          const numEnd = parseInt(numEndStr, 10);
          if (numStart <= numEnd && (numEnd - numStart) <= 100) {
            const list = [];
            const padLength = numStartStr.length;
            for (let i = numStart; i <= numEnd; i++) {
              const paddedNum = String(i).padStart(padLength, '0');
              list.push(`${prefixStart}${paddedNum}`);
            }
            return list;
          }
        }
      }

      // Fallback: just return start and end parts as-is (e.g. PQ763484.1-PV340651.1)
      return [startAcc, endAcc];
    },
  },
  computed: {
    groupList() {
      const filtered = this.flattenedTaxonomy.filter(item => 
        (!this.userInputClass || item.class === this.userInputClass) &&
        (!this.userInputOrder || item.order === this.userInputOrder) &&
        (!this.userInputFamily || item.family === this.userInputFamily) &&
        (!this.userInputGenus || item.genus === this.userInputGenus)
      );
      return Array.from(new Set(filtered.map(i => i.group))).sort().map(val => ({ value: val, label: val }));
    },
    classList() {
      const filtered = this.flattenedTaxonomy.filter(item => 
        (!this.userInputGroup || item.group === this.userInputGroup) &&
        (!this.userInputOrder || item.order === this.userInputOrder) &&
        (!this.userInputFamily || item.family === this.userInputFamily) &&
        (!this.userInputGenus || item.genus === this.userInputGenus)
      );
      return Array.from(new Set(filtered.map(i => i.class))).sort().map(val => ({ value: val, label: val }));
    },
    orderList() {
      const filtered = this.flattenedTaxonomy.filter(item => 
        (!this.userInputGroup || item.group === this.userInputGroup) &&
        (!this.userInputClass || item.class === this.userInputClass) &&
        (!this.userInputFamily || item.family === this.userInputFamily) &&
        (!this.userInputGenus || item.genus === this.userInputGenus)
      );
      return Array.from(new Set(filtered.map(i => i.order))).sort().map(val => ({ value: val, label: val }));
    },
    familyList() {
      const filtered = this.flattenedTaxonomy.filter(item => 
        (!this.userInputGroup || item.group === this.userInputGroup) &&
        (!this.userInputClass || item.class === this.userInputClass) &&
        (!this.userInputOrder || item.order === this.userInputOrder) &&
        (!this.userInputGenus || item.genus === this.userInputGenus)
      );
      return Array.from(new Set(filtered.map(i => i.family))).sort().map(val => ({ value: val, label: val }));
    },
    genusList() {
      const filtered = this.flattenedTaxonomy.filter(item => 
        (!this.userInputGroup || item.group === this.userInputGroup) &&
        (!this.userInputClass || item.class === this.userInputClass) &&
        (!this.userInputOrder || item.order === this.userInputOrder) &&
        (!this.userInputFamily || item.family === this.userInputFamily)
      );
      return Array.from(new Set(filtered.map(i => i.genus))).sort().map(val => ({ value: val, label: val }));
    },
    advanced: function () {
      return [
        { key: "Group", value: this.userInputGroup },
        { key: "Class", value: this.userInputClass },
        { key: "Order", value: this.userInputOrder },
        { key: "Family", value: this.userInputFamily },
        { key: "Genus", value: this.userInputGenus },
      ];
    },
  },
};
</script>
<style scoped>
.firstSearch {
  width: 200px;
  margin: 0px 0 10px 8px;
}
.A_Search {
  width: 200px;
  margin: 8px 0 10px 8px;
}
.Statistics {
  width: 100%;
  margin-bottom: 20px;
}
.Statistics svg {
  margin: 5px 0 8px 8px;
}
.title {
  width: 100%;
  display: flex;
}

.mycard {
  width: 1300px;
  margin: 20px auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12); /* 明显阴影，无hover特效 */
}

.inputs {
  width: 300px;
  margin: 0px 10px 10px 10px;
}

.inputs label {
  font-weight: 550;
}

.below {
  width: 1300px;
  margin: 20px auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}
.italic {
  font-style: italic;
}
</style>
